module.exports = __webpack_public_path__ + "img/team-member-02.377f4770.jpg";